#@import Booking.Presenters.Base
#@export Booking.Presenters.Picker

class Booking.Presenters.Picker extends Booking.Presenters.Base

  selected: ->
    throw new Error 'should implement'

  isLoading: ->
    @model.isDateTimeLoading()

  isSelectable: ->
    @collection.length > 1 or @model.isBookerDeal()

  toHash: ->
    icon:       @options.icon
    expanded:   @options.expanded
    selectable: @isSelectable() or not @selected()
    disabled:   !@isPreviousSelected()
    bhcTime:    'icon:ReEnterTime'
    bhcDate:    'icon:ReEnterDate'

  isPreviousSelected: ->
    if @options.previous and @options.previous.length > 0
      @options.previous[-1..][0].selected()
    else
      true
